/**
 * Default section reveal animation.
 */
export const sectionReveal = {
  hidden: {
    opacity: 0,
    y: 18,
    filter: "blur(6px)",
    transition: {
      duration: 0.24,
      ease: [0.22, 1, 0.36, 1] as const,
    },
  },
  visible: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: {
      type: "spring" as const,
      stiffness: 400,
      damping: 30,
    },
  },
};

/**
 * Default stagger container for grouped content.
 */
export const staggerContainer = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.07,
      delayChildren: 0.06,
    },
  },
};

/**
 * Standard child reveal animation.
 */
export const fadeUpItem = {
  hidden: {
    opacity: 0,
    y: 16,
    filter: "blur(5px)",
    transition: {
      duration: 0.22,
      ease: [0.22, 1, 0.36, 1] as const,
    },
  },
  visible: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: {
      type: "spring" as const,
      stiffness: 400,
      damping: 30,
    },
  },
};

/**
 * Larger hero reveal for primary visual blocks.
 */
export const heroVisualReveal = {
  hidden: {
    opacity: 0,
    y: 28,
    scale: 0.96,
    filter: "blur(8px)",
    transition: {
      duration: 0.26,
      ease: [0.22, 1, 0.36, 1] as const,
    },
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    filter: "blur(0px)",
    transition: {
      type: "spring" as const,
      stiffness: 260,
      damping: 28,
      delay: 0.12,
    },
  },
};

/**
 * Directional reveal used for alternating layouts.
 */
export const slideInFrom = (direction: "left" | "right") => ({
  hidden: {
    opacity: 0,
    x: direction === "left" ? -28 : 28,
    filter: "blur(6px)",
    transition: {
      duration: 0.22,
      ease: [0.22, 1, 0.36, 1] as const,
    },
  },
  visible: {
    opacity: 1,
    x: 0,
    filter: "blur(0px)",
    transition: {
      type: "spring" as const,
      stiffness: 360,
      damping: 32,
    },
  },
});

/**
 * Shared card interaction physics.
 */
export const cardHover = {
  y: -4,
  transition: {
    type: "spring" as const,
    stiffness: 420,
    damping: 30,
  },
};
